import React, { Component } from "react";
// import { useParams } from "react-router-dom";
import { loginService } from "../../services/login.service";
import { helperText } from "../../_helpers/helpertext";
import Loader from "../../_helpers/Loader";
import { isStringEmpty } from "../../_helpers/string_helper";
import { historypush } from "../../_helpers/utilities";
import eye from "../../Images/eye.png";

// function withParams(Component) {
//   return props => <Component {...props} params={useParams()} />;
// }

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      isLoading: false,
      guidtoSend:"",
      errorMessage:"",
      showPassword: false,
      showConfirmPassword: false,
      showSuccessMessage:false,
    };
  }

  componentDidMount = async() => {
    // let { guid } = this.props.params;
    // this.setState({
    //   guidtoSend:guid,
    // })
    // if(guid!=undefined){
      var result = new URLSearchParams(window.location.search).get("guid");
         this.setState({
          guidtoSend:result,
          isLoading : true,
      })
      var response = await loginService.CheckIfLinkValid(result);
      if(response.status === 200){
        if(response.data === false){
          //redirect
          historypush("/errorPage")
        }else{
          this.setState({isLoading : false});
        }
      }else{
        this.setState({isLoading : false});
      }
  };

  changePassword = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  /* <summary>
  date: 27-06-2022
  Name: VD
  description: This is used to check if the password entered is correct or not
  <summary>*/ 
  validate = () => {
    
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    const { password, confirmPassword,guidtoSend } = this.state;
    if(isStringEmpty(password)){
      this.setState({
        errorMessage: helperText.resetPageText.emptyPassword,
      })
    }
    if (password === confirmPassword) {
      if(format.test(password)){
        if (password.length > 7) {
          this.updatePassword(guidtoSend,password);
        } else {
          this.setState({
            errorMessage: helperText.resetPageText.passwordLength,
          });
        }
      }else{
        this.setState({
            errorMessage: helperText.resetPageText.specialCharacterMissing,
        })
      }
    } else {
      this.setState({
        errorMessage: helperText.resetPageText.unMatchPassword,
      });
    }
  };

  updatePassword = async (guid,password) => {
    try{
      this.setState({
        isLoading: true,
      });
      var response = await loginService.updatePassword(guid,password);
      if (response.status === 200) {
        //if(response.data=='true'){
          this.setState({
            showSuccessMessage: true,
          });
        // }else{
        //   this.setState({
        //     popUpModalText: helperText.resetPageText.urlAlreadyUsed,
        //     showPopupModal: true,
        //     messageType:MessageType.Failure,
        //   });
        // }

        historypush('/login');
      }
      this.setState({
        isLoading: false,
      });
      }catch (ex) {
        return "";
      }
  };

  toggleEye = () => {
    const currentState = this.state.showPassword;
    this.setState({ showPassword: !currentState });
  };

  toggleConfirmEye = () => {
      const currentState = this.state.showConfirmPassword;
      this.setState({ showConfirmPassword: !currentState });
  };
    
  render() {
    const {
      password,
      confirmPassword,
      errorMessage,
      isLoading,
      showPassword,
      showConfirmPassword,
      showSuccessMessage,
    } = this.state;
    return (
      <div>
        
            {isLoading && <Loader />}
        <div className="container">
            <div className="Login-form">
              <h2>Forgot Password</h2>
              <p style={{padding: '15px 0px'}}>(Min. 8 characters containing at least 1 special character)</p>
              <label htmlFor="pwd">Enter New Password:</label>
              <input 
                type={showPassword ? "text" : "password"}
                className="form-control" 
                id="pwd" 
                value={password}
                name="password"
                onChange={(e) => this.changePassword(e)} />
                <img
                        style={{ marginLeft: "90%", marginTop: "-115px",cursor :'pointer' }}
                        src={eye}
                        onClick={this.toggleEye}
                        alt="Eye"
                    />
              <br />
              <label htmlFor="pwd">Confirm your Password:</label>
              <input 
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                id="pwd"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => this.changePassword(e)} />
                <img
                        style={{ marginLeft: "90%", marginTop: "-115px",cursor :'pointer' }}
                        src={eye}
                        onClick={this.toggleConfirmEye}
                        alt="Eye"
                    />
              <br />
              <div style={{paddingLeft:"13px",marginTop:'-47px',color:'red'}}>{errorMessage}</div>
              {showSuccessMessage && (
                <div id="thank_you" className="alert alert-success alert-dismissible" style={{ fontSize: '16px'}}>
                  {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                  <button type="button" className="btn-close" data-bs-dismiss="alert" />
                  Your Password has been updated.
                </div>
              )}
              <div className="d-grid">
                <button 
                  type="button" 
                  className="btn btn-block Login-btn" 
                  formNoValidate="formnovalidate"
                  onClick={() => this.validate()}
                  style={{marginTop:'10px'}}
                >Update</button>
              </div>
              <div style={{paddingTop: '20px', textAlign: 'center'}}>
                <a href="/login">Back to login</a>
              </div>
            </div>
        </div>
      </div>
    );
  }
}


export default ResetPassword;